/**
 * ComparisonCharts - product comparison chart/table block.
 * Custom element: <comparison-charts>
 *
 * Refs:
 *   [data-ref="specList"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import { throttle } from "./vendor.js";
class ComparisonCharts extends ThemeComponent {
  init() {
    if (this.buildHeadingColumn(), setTimeout(() => {
      this.setHeadingRowHeights();
    }, 300), window.outerWidth >= 1024) {
      this.setRowHeights();
      const specNameElements = this.querySelectorAll('dt[data-ref="spec-name"]');
      for (const specName of specNameElements) specName.classList.add("visually-hidden");
    }
    this.$listen(window, "resize", throttle(() => {
      if (window.outerWidth >= 1024) this.setHeadingRowHeights(), this.setRowHeights();else {
        this.RemoveHeights();
        const specNameElements = this.querySelectorAll('dt[data-ref="spec-name"]');
        for (const specName of specNameElements) specName.classList.remove("visually-hidden");
      }
    }, 1e3)), new MutationObserver((mutations, bodyObserver) => {
      const titlesElement = document.querySelector(".comparison-charts__titles");
      titlesElement && (bodyObserver.disconnect(), new MutationObserver(titleMutations => {
        this.setRowHeights();
      }).observe(titlesElement, {
        childList: !0,
        subtree: !0
      }));
    }).observe(document.body, {
      childList: !0,
      subtree: !0
    });
  }
  buildHeadingColumn() {
    const specList = this.specList,
      exampleSpecs = this.exampleCard() || [];
    specList.innerHTML = "";
    for (const spec of exampleSpecs) {
      const listItemHtml = `<li class="flex flex-column gap-10 mb-20 text-capitalize">${spec.textContent}</li>`;
      specList.insertAdjacentHTML("beforeend", listItemHtml);
    }
  }
  exampleCard() {
    const specCards = this.querySelectorAll(".product-card-specs");
    let maxSpecCount = 0,
      largestSpecList = null;
    for (const card of specCards) {
      const specNames = card.querySelectorAll('dt[data-ref="spec-name"]'),
        specCount = specNames.length;
      !isNaN(specCount) && specCount > maxSpecCount && (maxSpecCount = specNames.length, largestSpecList = specNames);
    }
    return largestSpecList;
  }
  setHeadingRowHeights() {
    const titleElements = this.querySelectorAll(".product-card__title_pricing");
    let heights = [];
    Array.from(titleElements).map((titleElement, index) => {
      heights[index] = titleElement.offsetHeight || 0;
    });
    const maxHeight = Math.max(...heights),
      headingElement = this.querySelector(".comparison-charts__heading"),
      titleElementsAgain = this.querySelectorAll(".product-card__title_pricing");
    if (headingElement && (headingElement.style.height = `${maxHeight}px`), titleElementsAgain) for (const currentTitleElement of titleElementsAgain) currentTitleElement.style.height = `${maxHeight}px`;
  }
  setRowHeights() {
    const specListItems = this.specList.querySelectorAll("li"),
      productCards = this.querySelectorAll(".product-card");
    Array.from(specListItems).map((specListItem, rowIndex) => {
      const rowHeight = specListItem.offsetHeight || 0;
      Array.from(productCards).map(productCard => {
        const specValueElement = productCard.querySelectorAll('[data-ref="spec-value"]')[rowIndex];
        specValueElement && (specValueElement.style.height = `${rowHeight}px`);
      });
    });
  }
  RemoveHeights() {
    const specValueElements = this.querySelectorAll('[data-ref="spec-value"]');
    Array.from(specValueElements).map(specValueElement => {
      specValueElement.removeAttribute("style");
    });
  }
}
setFunctionName(ComparisonCharts, "ComparisonCharts");
const propertyTypes = {};
ComparisonCharts.prototype.$name = "ComparisonCharts";
ComparisonCharts.prototype.$info = JSON.parse('{"name":"ComparisonCharts","meta":{"isLegacy":false,"selector":"comparison-charts"},"props":[],"refs":[{"selector":"[data-ref=\\"specList\\"]","required":false,"propertyKey":"specList","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"any"}]}');
ComparisonCharts.prototype.$info.component = ComparisonCharts;
for (const prop of ComparisonCharts.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("ComparisonCharts/ComparisonCharts.ts", {
  ComparisonCharts: ComparisonCharts
}, void 0);